/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import KImage from '@/types/KImage'

class ProviderCard {
  public readonly networkText: string;
  public readonly savingsText: string;
  public readonly providerText: string;
  public readonly memberCostText: string;
  public readonly isPlusProvider: boolean;
  public readonly plusProviderIcon?: KImage;
  public readonly plusColor: string;

  constructor (json: any, asPlusProvider: boolean) {
    this.isPlusProvider = asPlusProvider
    this.networkText = json.in_network
    this.savingsText = json.you_save
    this.providerText = asPlusProvider ? json.plus_provider : json.nonplus_provider
    this.memberCostText = json.member_cost
    this.plusColor = json.plus_color

    if (asPlusProvider) {
      this.plusProviderIcon = new KImage(json.plus_provider_icon.url, json.plus_provider_icon.content_type)
    }
  }

  static of (json: any, asPlusProvider: boolean): ProviderCard {
    return new ProviderCard(json, asPlusProvider)
  }
}

export default ProviderCard
